var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.show)?_c('el-alert',{staticClass:"mb-3",attrs:{"type":"warning","title":_vm.title,"closable":false,"show-icon":""}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }